import React, { useEffect } from 'react';
import { Trash2, X } from 'lucide-react';
import LoadingIndicator from './LoadingIndicator';
import './DeleteSavingsPlanModal.css';

const DeleteSavingsPlanModal = ({
  isOpen,
  planName = '',
  planType = '',
  isDeleting = false,
  onClose,
  onConfirm,
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape' && !isDeleting) onClose?.();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, isDeleting, onClose]);

  if (!isOpen) return null;

  const name = String(planName || 'this savings plan').trim() || 'this savings plan';
  const typeLabel = String(planType || '').trim();
  const showType = typeLabel && typeLabel.toLowerCase() !== 'savings';

  return (
    <div
      className="savings-delete-overlay"
      role="presentation"
      onClick={() => {
        if (!isDeleting) onClose?.();
      }}
    >
      <div
        className="savings-delete-sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby="savings-delete-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="savings-delete-head">
          <h2 id="savings-delete-title" className="savings-delete-title">
            Delete savings plan
          </h2>
          <button
            type="button"
            className="savings-delete-close"
            onClick={onClose}
            disabled={isDeleting}
            aria-label="Close"
          >
            <X size={22} strokeWidth={2} />
          </button>
        </header>

        <div className="savings-delete-icon" aria-hidden>
          <Trash2 size={22} strokeWidth={2} />
        </div>

        <p className="savings-delete-lead">
          Delete <strong>{name}</strong>? This removes the plan and cannot be undone.
        </p>
        {showType ? <p className="savings-delete-type">{typeLabel}</p> : null}

        <div className="savings-delete-actions">
          <button
            type="button"
            className="savings-delete-cancel"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="savings-delete-confirm"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <LoadingIndicator size="sm" />
                <span>Deleting…</span>
              </>
            ) : (
              'Delete plan'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteSavingsPlanModal;
